import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind-aware className composer. Standard shadcn pattern.
 *
 *   cn('px-2', condition && 'px-4', extraClass)
 *
 * clsx handles conditional + array inputs.
 * twMerge dedupes conflicting Tailwind utilities (the later wins, like
 * `px-2 px-4` collapses to `px-4` rather than emitting both).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
